import React, { Component } from 'react';

//components
import CustomButton from "../../../../generic_components/components/buttons/CustomButton";

//generic functions
import {
    isEmpty
} from "../../../../functions/generic_functions";

//regex email string
import {
    emailRegex
} from "../../../../static_data/static_strings";

//router
import { 
    withRouter
} from 'react-router-dom';

//static routes
import {
    cari_home_pg_url
} from "../../../../router/static_routes";

//redux
import { connect } from "react-redux";
import {
    resetCariActiveData
} from "../../../../redux/actions/indexActions";

//redux mappers
const mapStateToProps = state => {
    return {
        activeVerifiedLoginUserData: state.cariReducer.activeVerifiedLoginUserData,
        activeUserData: state.cariReducer.activeUserData
    };
};
const mapDispatchToProps = dispatch => {
    return {
        resetCariActiveData: () => {
            dispatch(resetCariActiveData())
        },
    };
};

class CariLoginPanel extends Component {

    state = {  }

    constructor(props) {
        super(props);

        //action handlers
        this.handleOnClickSignOut = this.handleOnClickSignOut.bind(this);

        //get user data
        this.getActiveUserDataFromStore = this.getActiveUserDataFromStore.bind(this);
        this.checkIfUserDataExists = this.checkIfUserDataExists.bind(this);

        //regex for email
        this.checkIfValidEmailRegex = this.checkIfValidEmailRegex.bind(this);
    }
    

    //get active position data from redux store
    getActiveUserDataFromStore() {
        var copyUserData = this.props.activeUserData;
        return copyUserData;
    }

    checkIfValidEmailRegex(test_str) {
        var pattern = new RegExp(emailRegex);
        return pattern.test(test_str);
    }


    //returns boolean if user data from redux store exists and is valid: valid email, valid token, first name and last name is not empty
    checkIfUserDataExists() {
        if (!isEmpty(this.props.activeUserData)
            && !isEmpty(this.props.activeVerifiedLoginUserData)
            && !isEmpty(this.props.activeVerifiedLoginUserData.email)
            && this.checkIfValidEmailRegex(this.props.activeVerifiedLoginUserData.email)
            && !isEmpty(this.props.activeVerifiedLoginUserData.token)
            && !isEmpty(this.props.activeUserData.first_name)
            && !isEmpty(this.props.activeUserData.last_name)
        ) {
            return true;
        }
        else {
            return false;
        }
    }
    //on click of log out, reset redux data store and redirect to login page
    handleOnClickSignOut() {
        //reset all active data
        this.props.resetCariActiveData();

        document.title = "Continuing Academic Positions";

        //redirect back to home page cari
        this.props.history.push(cari_home_pg_url);
    }

    render() { 
        return (  
            <React.Fragment>
                {this.checkIfUserDataExists() ?
                    <React.Fragment>
                        <div className="">
                            
                            <div className="p-grid">
                                <div className="p-col-12 sign_out_btn">
                                    <label className="logged_in_as_style">Logged in as: </label>
                                </div>    
                            </div>  

                            <div className="p-grid">
                                <div className="p-col-12 sign_out_btn">
                                    <strong className="logged_in_user_name_color">
                                        {this.getActiveUserDataFromStore().first_name}
                                        &nbsp;
                                        {this.getActiveUserDataFromStore().last_name}
                                    </strong> 
                                </div>
                                <div className="p-col-12 sign_out_btn">
                                    <CustomButton
                                        onClickSetParentState={this.handleOnClickSignOut}
                                        btnRaised={true}
                                        textOnly={true}
                                        className={"p-button-sfu-red log_out_btn_font"}
                                        label={"Sign out"}
                                    />
                                </div>
                            </div>          
                        </div>
                    </React.Fragment>
                : null}
            </React.Fragment>
        );
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CariLoginPanel));